import axios from 'axios';

// 환경변수 기본값 설정
// 운영 환경에서는 상대 경로 사용 (같은 도메인)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/acghr';

// Axios 인스턴스 생성
const api = axios.create({
  baseURL: API_BASE_URL + API_PREFIX,
  timeout: 30000,
  withCredentials: true, // 세션 쿠키 전송 허용
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.config.url, response.status);
    return response;
  },
  (error) => {
    console.error('Response Error:', error.response?.status, error.response?.data);

    // 인증 오류 처리 - 로그인 페이지가 아닐 때만 리다이렉트
    if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
      // 로그인 페이지로 리다이렉트
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
